@import ../../../styles/helpers

.gamesGrid
    display: grid
    width: 100%
    height: fit-content
    grid-template-columns: repeat( auto-fill, minmax( 275px, 1fr ) )
    gap: $external_margin $external_margin
    margin: 0 auto
    +m
        grid-template-columns: none
        gap: 0
        button
            display: flex
            padding: 20px !important
            border-radius: 35px
            margin-top: 0 !important
        button:nth-child(odd)
            background-color: $bordercolor


